import styled from 'styled-components';
import { COLORS, FONT_FAMILY } from '@Commons';

export const CardContainer = styled.div`
  display: flex;
  border: 1px solid ${COLORS.borderGrey};
  border-radius: 2px;
  padding: 16px;
  background-color: ${COLORS.white};
  gap: 10px;
  align-items: stretch;

  .seperation-line {
    width: 1px;
    background-color: ${COLORS.borderGrey};
  }
`;

export const Icon = styled.div`
  width: 24px;
  height: 24px;
  align-self: center;
  display: flex;
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
`;

export const Name = styled.div`
  font-size: 16px;
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${COLORS.black};
`;

export const Type = styled.div`
  font-size: 14px;
  color: ${COLORS.black};
  margin-top: 4px;
`;
